<template>
  <div class="header">
      <a href="https://vibbra.com.br">
        <img src="../../assets/icons/logo_vibbra.svg" class="logo" />
      </a>
     <slot class="link"></slot>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    backTo: {
      type: String,
      required: false,
      default: 'Default Text'
    }
  }
};
</script>

<style lang="scss">
.header {
  display: flex;
  background: black;
  width: 100%;
  padding: 1rem 10rem;
  justify-content: space-between;
  align-items: center;
  color: white;

  .logo {
    width: 100px;
  }

  .link{
    color: white !important;

    &:hover{
      color: #0377AA !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/parts/components/header.vue